import React from 'react';

/* A field people never see and bots fill in. It sits off screen rather than
   display: none, because some bots skip fields that are plainly hidden, and it
   is out of the tab order and hidden from screen readers so nobody lands in it.
   The server refuses any submission where it has a value. */
const BotTrap = () => (
    <div aria-hidden={'true'} style={{ height: 1, left: -10000, overflow: 'hidden', position: 'absolute', top: 'auto', width: 1 }}>
        <label>
            {'Company website'}
            <input autoComplete={'off'} name={'company_website'} tabIndex={-1} type={'text'} defaultValue={''} />
        </label>
    </div>
)

// what the form's trap field holds when it's submitted, sent as company_website
export const trapValue = evt => {
    const field = evt && evt.currentTarget && evt.currentTarget.elements ? evt.currentTarget.elements.company_website : null;
    return field ? field.value : '';
}

export default BotTrap;
